module.exports = __webpack_public_path__ + "img/chest.931c50d1.png";